import React from "react";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const TopBar = () => {
  return (
    <div
      style={{
        backgroundColor: "rgba(0, 0, 51, 0.6)",
        color: "#fff",
        padding: "10px 20px",
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 10000,
        backdropFilter: "blur(8px)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          // justifyContent: "space-between", 
          alignItems: "center",
          flexWrap: "wrap",
          rowGap: "10px",
          fontSize: "14px",
        }}
      >
        {/* Contact Section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            flexWrap: "wrap",
          }}
        >
          {/* Email */}
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=ifo@trinestsky.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              textDecoration: "none",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            <FaEnvelope style={{ color: "#fda94f" }} />
             info@trinestsky.com
          </a>

          {/* Phone */}
          <div
            onClick={(e) => {
              const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
              if (!isMobile) {
                e.preventDefault();
                alert("Calling is only supported on mobile devices.");
              } else {
                window.location.href = "tel:+045771575";
              }
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
            }}
          >
            <FaPhoneAlt style={{ color: "#fda94f" }} />
            <span>+045771575</span>
          </div>
        </div>

        {/* Social Links */}
        {/* <div style={{ display: "flex", gap: "12px", fontSize: "16px" }}>
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <i className="fa fa-facebook" style={{ color: "#fda94f" }}></i>
          </a>
          <a href="https://x.com" target="_blank" rel="noreferrer">
            <img
              src="/icons8-x-50.png"
              alt="X"
              style={{ width: "15px", marginTop: "-2px" }}
            />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noreferrer">
            <i className="fa fa-linkedin" style={{ color: "#fda94f" }}></i>
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            <i className="fa fa-instagram" style={{ color: "#fda94f" }}></i>
          </a>
          <a href="https://youtube.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-youtube" style={{ color: "#fda94f" }}></i>
          </a>
          <a href="https://tiktok.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-tiktok" style={{ color: "#fda94f" }}></i>
          </a>
        </div> */}
      </div>

      {/* Mobile responsive fix */}
      <style>{`
        @media (max-width: 768px) {
          div[style*="justify-content: space-between"] {
            flex-direction: column;
            align-items: center;
            gap: 10px;
            font-size: 13px;
            text-align: center;
          }
        }
      `}</style>
    </div>
  );
};

export default TopBar;
